import React, { useState, useContext, useEffect } from "react";
// import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import "./rms.css";
// import { useState } from "react";
import { Typography } from "@material-ui/core";
import { StoreContext } from "../../../store/Provider";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useLocation } from "react-router-dom";
const QuoteTable = ({
  detailsResult,
  setExpandedInTable,
  expandedInTable,
  setExpandedInTable2,
  expandedInTable2,
}) => {
  console.log(detailsResult, "detailsResult111");
  const [expanded, setExpanded] = useState(true);
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedInTable(isExpanded ? panel : false);
    // setExpandedInTable2(false);
  };
  const handleAccordionChange2 = (panel) => (event, isExpanded) => {
    setExpandedInTable2(isExpanded ? panel : false);
    // setExpandedInTable(false);
  };
  const location = useLocation();
  const status = location.pathname.split("/").at(-1);
  const [containerSelected, setContainerSelected] = useState("");
  const [toShowRateArray, setToShowRateArray] = useState([]);

  const dateComparison = () => {
    var dictionary = {
      "Quote generated at ": new Date(detailsResult.quoteGeneratedAt),
      "Booking made at ": new Date(detailsResult.bookingMadeAt),
      "Booking confirmed at ": new Date(detailsResult.bookingConfirmedAt),
    };

    var maxDate = new Date("0001-01-01T00:00:00");
    var latestKey = "";

    for (var key in dictionary) {
      var currentDate = dictionary[key];
      if (currentDate > maxDate) {
        maxDate = currentDate;
        latestKey = key;
      }
    }

    var latestDate = {
      key: latestKey,
      value: maxDate,
    };

    return latestDate;
  };
  useEffect(() => {
    let arry = Object.keys(detailsResult);
    let containerSelected = arry.filter((ele) => {
      if (ele.endsWith("ContainerSelected")) {
        if (detailsResult[ele] === true) return ele;
      }
    });

    console.log("containerSelected", containerSelected);
    let numberOfUnitPerContainer = [];
    arry.forEach((ele) => {
      if (ele.endsWith("ContainerCount")) {
        if (detailsResult[ele] > 0) {
          let value = detailsResult[ele];
          numberOfUnitPerContainer.push(value);
        }
      }
    });
    console.log("numberOfUnitPerContainer", numberOfUnitPerContainer);
    let SelectedContainerRates = [];
    arry.forEach((ele) => {
      if (ele.endsWith("ContainerRate")) {
        if (detailsResult[ele] > 0) {
          let value = detailsResult[ele];
          SelectedContainerRates.push(value);
        }
      }
    });
    console.log("SelectedContainerRates", SelectedContainerRates);

    containerSelected = containerSelected.map((text) => {
      let result = text.replace("is", "");
      result = result.replace("ContainerSelected", "");
      const match = result.match(/(\d+)$/);
      if (match) {
        const digits = match[1];
        const prefix = result.slice(0, -digits.length);
        return digits + prefix;
      } else {
        // If no digits found at the end, return the input as is.
        return result;
      }
    });
    console.log("numberOfcontainerSelectedUnitPerContainer", containerSelected);

    const output = containerSelected.map(
      (value, index) => `${value} - ${numberOfUnitPerContainer[index] ?? 0}`
    );

    let finalAns = output.join(", ");
    setContainerSelected(finalAns);
    const output1 = containerSelected.map((value, index) => {
      const result =
        (SelectedContainerRates[index] ?? 0) *
        (numberOfUnitPerContainer[index] ?? 0);
      return `${value} : ${SelectedContainerRates[index]} * ${
        numberOfUnitPerContainer[index] ?? 0
      } = ${result.toFixed(2)}`;
    });

    console.log(output1, "output1");
    setToShowRateArray(output1);
  }, [detailsResult]);
  const context = React.useContext(StoreContext);

  return (
    <>
      <TableContainer style={{ fontFamily: "Open Sans, sans-serif" }}>
        <Table
          sx={{ minWidth: 550 }}
          aria-label="simple table"
          className="table-data"
        >
          <TableRow>
            <TableCell style={{ padding: "5px", fontFamily: "Open Sans" }}>
              {" "}
              <div className="d-flex justify-content-between">
                {detailsResult?.isBooked ? (
                  <span>Booking Id:</span>
                ) : (
                  <span>
                    {detailsResult?.isHazardous ? null : <span>Quote</span>} ID
                  </span>
                )}
                <span>:</span>
              </div>{" "}
            </TableCell>

            <TableCell style={{ padding: "5px", fontWeight: "bold" }}>
              {detailsResult.quote_BookingId ?? "N/A"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={{ padding: "5px", fontFamily: "Open Sans" }}>
              {" "}
              <div className="d-flex justify-content-between">
                <span>Name of the Company</span>
                <span>:</span>
              </div>{" "}
            </TableCell>

            <TableCell style={{ padding: "5px" }}>
              {detailsResult.quoteForCompanyCode ??
                detailsResult.bookingMadeForCompanyCode ??
                "N/A"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ padding: "5px" }}>
              <div className="d-flex justify-content-between">
                <span>Contact Info</span>
                <span>:</span>
              </div>{" "}
            </TableCell>
            <TableCell style={{ padding: "5px" }}>
              {detailsResult.emailIdOfUser ?? "N/A"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ padding: "5px" }}>
              <div className="d-flex justify-content-between">
                <span> Port of loading</span>
                <span>:</span>
              </div>{" "}
            </TableCell>
            <TableCell style={{ padding: "5px" }}>
              {detailsResult.freightOrigin ?? detailsResult.polName ?? "N/A"} (
              {detailsResult.freightOriginCode ?? detailsResult.pol ?? "N/A"})
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ padding: "5px" }}>
              <div className="d-flex justify-content-between">
                <span>
                  {" "}
                  {status === "lcl"
                    ? "Port of discharge"
                    : "Port of destination"}{" "}
                </span>
                <span>:</span>
              </div>{" "}
            </TableCell>
            <TableCell style={{ padding: "5px" }}>
              {detailsResult.ipiDestination ??
                detailsResult?.destinationName ??
                "N/A"}{" "}
              (
              {detailsResult.ipiDestinationCode ??
                detailsResult?.destination ??
                "N/A"}
              )
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ padding: "5px" }}>
              <div className="d-flex justify-content-between">
                <span> Freight carrier</span>
                <span>:</span>
              </div>{" "}
            </TableCell>
            <TableCell style={{ padding: "5px" }}>
              {detailsResult?.isHazardous
                ? "N/A"
                : detailsResult.freightCarrier ??
                  detailsResult.carrier ??
                  "N/A"}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ padding: "5px" }}>
              <div className="d-flex justify-content-between">
                <span> Freight route</span>
                <span>:</span>
              </div>{" "}
            </TableCell>
            <TableCell style={{ padding: "5px" }}>
              {detailsResult.freightRoute ?? detailsResult.routing.length === 0
                ? "N/A"
                : detailsResult.routing ?? "N/A"}
            </TableCell>
          </TableRow>
          {status === "lcl" ? (
            <TableRow>
              <TableCell style={{ padding: "5px" }}>
                <div className="d-flex justify-content-between">
                  <span>Last mile delivery address</span>
                  <span>:</span>
                </div>
              </TableCell>
              <TableCell style={{ padding: "5px" }}>
                {detailsResult.isLMDOpted
                  ? `${detailsResult.lmdDestinationAddress ?? "N/A"} ( ${
                      detailsResult.originZipCode
                    } to ${detailsResult.destinationZipCode})`
                  : "Not opted"}
              </TableCell>
            </TableRow>
          ) : (
            <>
              {
                <TableRow>
                  <TableCell style={{ padding: "5px" }}>
                    <div className="d-flex justify-content-between">
                      <span>Container (Type - Unit) Selected</span>
                      <span>:</span>
                    </div>
                  </TableCell>
                  <TableCell style={{ padding: "5px" }}>
                    {containerSelected.length > 0 ? containerSelected : "N/A"}
                  </TableCell>
                </TableRow>
              }
              {detailsResult.amendmentID !== "AmendmentID" && (
                <TableRow>
                  <TableCell style={{ padding: "5px" }}>
                    <div className="d-flex justify-content-between">
                      <span>AmendmentID</span>
                      <span>:</span>
                    </div>
                  </TableCell>
                  <TableCell style={{ padding: "5px" }}>
                    {detailsResult?.isHazardous
                      ? "N/A"
                      : detailsResult.amendmentID ?? "N/A"}
                  </TableCell>
                </TableRow>
              )}
              {detailsResult.contractNo !== "ContractNo" && (
                <TableRow>
                  <TableCell style={{ padding: "5px" }}>
                    <div className="d-flex justify-content-between">
                      <span>ContractNo</span>
                      <span>:</span>
                    </div>
                  </TableCell>
                  <TableCell style={{ padding: "5px" }}>
                    {detailsResult?.isHazardous
                      ? "N/A"
                      : detailsResult.contractNo ?? "N/A"}
                  </TableCell>
                </TableRow>
              )}
              {detailsResult.freeDetention !== "FreeDetention" && (
                <TableRow>
                  <TableCell style={{ padding: "5px" }}>
                    <div className="d-flex justify-content-between">
                      <span>FreeDetention</span>
                      <span>:</span>
                    </div>
                  </TableCell>
                  <TableCell style={{ padding: "5px" }}>
                    {detailsResult?.isHazardous
                      ? "N/A"
                      : detailsResult.freeDetention ?? "N/A"}
                  </TableCell>
                </TableRow>
              )}
            </>
          )}

          {status === "fcl" && !detailsResult?.isHazardous ? (
            <>
              <TableRow>
                <TableCell style={{ padding: "5px" }}>
                  <div className="d-flex justify-content-between">
                    <span>Rate valid upto</span>
                    <span>:</span>
                  </div>{" "}
                </TableCell>
                <TableCell style={{ padding: "5px" }}>
                  <b class="blinking-text">
                    {moment(detailsResult.expiringDate).format("MM/DD/YYYY") ??
                      "N/A"}
                  </b>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ padding: "5px" }}>
                  <div className="d-flex justify-content-between">
                    <span>Transit time</span>
                    <span>:</span>
                  </div>{" "}
                </TableCell>
                <TableCell style={{ padding: "5px" }}>
                  {detailsResult.tT_to_POD ?? "N/A"} Days
                </TableCell>
              </TableRow>
            </>
          ) : null}

          <TableRow>
            <TableCell style={{ padding: "5px" }}>
              <div className="d-flex justify-content-between">
                <span>Additional services, if selected</span>
                <span>:</span>
              </div>
            </TableCell>
            <TableCell style={{ padding: "5px" }}>
              Insurance: {detailsResult.isInsuraceOpted ?? "N/A" ? "Yes" : "No"}
              <br />
              Custom clearance:{" "}
              {detailsResult.isCustomClearaceOpted ?? "N/A" ? "Yes" : "No"}
            </TableCell>
          </TableRow>

          {/* <TableCell > </TableCell> */}
          {status === "lcl" && (
            <>
              <TableRow>
                <TableCell style={{ padding: "5px" }}>
                  <div className="d-flex justify-content-between">
                    <span> CBM of the cargo</span>
                    <span>:</span>
                  </div>
                </TableCell>
                <TableCell style={{ padding: "5px" }}>
                  {detailsResult.ipiQty ?? "N/A"} CBM
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ padding: "5px" }}>
                  <div className="d-flex justify-content-between">
                    <span>Weight of the cargo</span>
                    <span>:</span>
                  </div>{" "}
                </TableCell>
                <TableCell style={{ padding: "5px" }}>
                  {detailsResult.weight ?? "N/A"} Tonnes
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ padding: "5px" }}>
                  <div className="d-flex justify-content-between">
                    <span>Dimensions of the cargo</span>
                    <span>:</span>
                  </div>{" "}
                </TableCell>
                <TableCell style={{ padding: "5px" }}>
                  {`${detailsResult.dimensionLength ?? "N/A"} * ${
                    detailsResult.dimensionWidth ?? "N/A"
                  } * ${detailsResult.dimensionHeight ?? "N/A"}`}{" "}
                  Cubic ft.
                </TableCell>
              </TableRow>
            </>
          )}

          {!detailsResult?.isHazardous && (
            <>
              <TableRow>
                <TableCell
                  className="d-flex align-itmes-center"
                  style={{ padding: "5px" }}
                >
                  {" "}
                  <div
                    className="d-flex justify-content-between"
                    style={{ width: "100%" }}
                  >
                    <span>Total booking amount </span>

                    <span>:</span>
                  </div>
                </TableCell>
                <TableCell style={{ padding: "0px" }}>
                  <Accordion
                    expanded={expandedInTable === "panel1"}
                    onChange={handleAccordionChange("panel1")}
                    style={{ boxShadow: "none", padding: "5px 0px 0px 5px" }}
                    className="data"
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography
                        style={{
                          width: "100%",
                          flexShrink: 0,
                          fontSize: "0.875rem",
                          justifyContent: "flex-end",
                          padding: "0px",
                        }}
                      >
                        {detailsResult.totalQuotedAmount.toFixed(2) ?? "N/A"}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        style={{
                          fontSize: "14px",
                          textDecoration: "none",
                          fontWeight: "400",
                        }}
                      >
                        {status === "lcl" && (
                          <div className="d-flex justify-content-between">
                            {" "}
                            <div>Freight Charge:</div>
                            <div>
                              {(
                                detailsResult.freightQuoteAmount +
                                detailsResult.ipiQuoteAmount
                              ).toFixed(2)}
                            </div>
                          </div>
                        )}
                        {status === "fcl" &&
                          toShowRateArray.map((ele) => {
                            const data = ele.split(":");
                            return (
                              <div className="d-flex justify-content-between">
                                {" "}
                                <div>{data[0]}:</div>
                                <div>{data[1]}</div>
                              </div>
                            );
                          })}

                        <div className="d-flex justify-content-between">
                          {" "}
                          <div>Custom Clearance Charge:</div>
                          <div> {detailsResult.customClearaceAmount}</div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div> Insurance Charge:</div>
                          <div>{detailsResult.insuraceAmount}</div>{" "}
                        </div>
                        {status === "lcl" && (
                          <div className="d-flex justify-content-between">
                            {" "}
                            <div>LMD Charge:</div>
                            <div>{detailsResult.lmdQuoteAmount}</div>
                          </div>
                        )}

                        {status === "lcl" && (
                          <div className="d-flex justify-content-between">
                            <div> Warehouse Charge:</div>
                            <div>{detailsResult.warehouseCharge}</div>{" "}
                          </div>
                        )}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="d-flex align-itmes-center"
                  style={{ padding: "5px" }}
                >
                  {" "}
                  <div
                    className="d-flex justify-content-between"
                    style={{ width: "100%" }}
                  >
                    <span>{dateComparison().key}</span>

                    <span>:</span>
                  </div>
                </TableCell>
                <TableCell style={{ padding: "0px" }}>
                  <Accordion
                    defaultExpanded={expanded}
                    // expanded={expandedInTable2 === "panel1"}
                    onChange={handleAccordionChange2("panel1")}
                    style={{ boxShadow: "none" }}
                    className="data"
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography
                        style={{
                          width: "100%",
                          flexShrink: 0,
                          fontSize: "0.875rem",
                          justifyContent: "flex-end",
                          padding: "5px 0px 0px 5px",
                        }}
                      >
                        {moment(dateComparison().value).format(
                          "MM/DD/YYYY hh:mm a"
                        )}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        style={{
                          fontSize: "14px",
                          textDecoration: "none",
                          fontWeight: "400",
                          paddingLeft: "5px",
                        }}
                      >
                        <div className="d-flex justify-content-between">
                          {" "}
                          <div>Quote generated at :</div>
                          <div>
                            {moment(detailsResult.quoteGeneratedAt).format(
                              "MM/DD/YYYY hh:mm:ss"
                            ) === "01/01/0001 12:00:00"
                              ? "Yet to be generated"
                              : moment(detailsResult.quoteGeneratedAt).format(
                                  "MM/DD/YYYY hh:mm a"
                                )}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between">
                          {" "}
                          <div>Booking made at :</div>
                          <div>
                            {moment(detailsResult.bookingMadeAt).format(
                              "MM/DD/YYYY hh:mm:ss"
                            ) === "01/01/0001 12:00:00"
                              ? "Yet to be Booked"
                              : moment(detailsResult.bookingMadeAt).format(
                                  "MM/DD/YYYY hh:mm a"
                                )}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between">
                          {" "}
                          <div>Booking confirmed at:</div>
                          <div>
                            {" "}
                            {moment(detailsResult.bookingConfirmedAt).format(
                              "MM/DD/YYYY hh:mm:ss"
                            ) === "01/01/0001 12:00:00"
                              ? "Yet to be Confirmed"
                              : moment(detailsResult.bookingConfirmedAt).format(
                                  "MM/DD/YYYY hh:mm a"
                                )}
                          </div>
                        </div>
                        {/* <div className="d-flex justify-content-between">
                      <div> Insurance Charge:</div>
                      <div>{detailsResult.insuraceAmount}</div>{" "}
                    </div>
                    <div className="d-flex justify-content-between">
                      <div> Warehouse Charge:</div>
                      <div>{detailsResult.warehouseCharge}</div>{" "}
                    </div> */}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </TableCell>
              </TableRow>
            </>
          )}
        </Table>
      </TableContainer>
    </>
  );
};

export default QuoteTable;
